import "./Apache2Score.scss";
import { Header } from "../Header/Header";
import SideBar from "../SideBar/Sidebar";
import redRating from "../../common/icons/svg/red-rating.svg";
import yellowRating from "../../common/icons/svg/yellow-rating.svg";
import greenRating from "../../common/icons/svg/green-rating.svg";
import React, { useState, useEffect } from 'react';

function Apache2Score(props) {
    const [chronicOrganInsufficiencyRating, setChronicOrganInsufficiencyRating] = useState(0);
    const [ageRating, setAgeRating] = useState(0);
    const [rectalTemperatureRating, setRectalTemperatureRating] = useState(0);
    const [arterialpHRating, setArterialpHRating] = useState(0);
    const [meanArterialPressureRating, setMeanArterialPressureRating] = useState(0);
    const [hrRating, setHrRating] = useState(0);
    const [serumSodiumRating, setSerumSodiumRating] = useState(0);
    const [serumPotassiumRating, setSerumPotassiumRating] = useState(0);
    const [acuteRenalFailureRating, setAcuteRenalFailureRating] = useState(0);
    const [serumCreatinineRating, setSerumCreatinineRating] = useState(0);
    const [hematocritRating, setHematocritRating] = useState(0);
    const [wbcRating, setWbcRating] = useState(0);
    const [oxygenationRating, setOxygenationRating] = useState(0);
    const [repiratoryRateRating, setRepiratoryRateRating] = useState(0);
    const [gcsScore, setGcsScore] = useState(0);
    const [acuteYesNo, setAcuteYesNo] = useState('');
    const [totalScore, setTotalScore] = useState(0);

    const handleChronicOrganInsufficiencyRadio = (rating) => {
        setChronicOrganInsufficiencyRating(rating);
    }
    const handleAgeRadio = (rating) => {
        setAgeRating(rating);
    }
    const handleRectalTemperatureRadio = (rating) => {
        setRectalTemperatureRating(rating);
    }
    const handleArterialpHRadio = (rating) => {
        setArterialpHRating(rating);
    }
    const handleMeanArterialPressureRadio = (rating) => {
        setMeanArterialPressureRating(rating);
    }
    const handleSerumSodiumRadio = (rating) => {
        setSerumSodiumRating(rating);
    }
    const handleSerumPotassiumRadio = (rating) => {
        setSerumPotassiumRating(rating);
    }
    const handleAcuteRenalFailureRadio = (rating) => {
        setAcuteRenalFailureRating(rating);
    }
    const handleSerumCreatinineRadio = (rating) => {
        setSerumCreatinineRating(rating);
    }
    const handleHematocritRadio = (rating) => {
        setHematocritRating(rating);
    }
    const handleWbcRadio = (rating) => {
        setWbcRating(rating);
    }
    const handleOxygenationRadio = (rating) => {
        setOxygenationRating(rating);
    }
    const handleRespiratoryRateRadio = (rating) => {
        setRepiratoryRateRating(rating);
    }
    const handleGcsScoreRadio = (rating) => {
        rating = rating.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');
        setGcsScore(parseInt(rating ? (15 - rating) : 0));
    }
    const handleHrRadio = (rating) => {
        setHrRating(rating);
    }
    useEffect(() => {
        setTotalScore(
            chronicOrganInsufficiencyRating +
            ageRating +
            rectalTemperatureRating +
            arterialpHRating +
            meanArterialPressureRating +
            hrRating +
            serumSodiumRating +
            serumPotassiumRating +
            acuteRenalFailureRating +
            serumCreatinineRating +
            hematocritRating +
            wbcRating +
            oxygenationRating +
            repiratoryRateRating +
            gcsScore);

    }, [chronicOrganInsufficiencyRating,
        ageRating,
        rectalTemperatureRating,
        arterialpHRating,
        meanArterialPressureRating,
        hrRating,
        serumSodiumRating,
        serumPotassiumRating,
        acuteRenalFailureRating,
        serumCreatinineRating,
        hematocritRating,
        wbcRating,
        oxygenationRating,
        repiratoryRateRating,
        gcsScore])

    return (
        <div className="apache-2-score-container">
            <Header
            // handleWardChange={(item) => setSelectedWard(item)}
            // wardOption={wardOption}
            // selectedWard={selectedWard} 
            />
            <SideBar />
            <div className="apache-2-score-body">
                <div className="score-top-header">
                    <div className="apache-2-heading-container">
                        <span className="heading">Apache II Score</span>
                        <div className={`show-score
                                        ${(totalScore > 29) ? "red-score" : ""} 
                                        ${(totalScore <= 29) && (totalScore >= 10) ? "yellow-score" : ""}
                                        ${(totalScore <= 9) && (totalScore >= 0) ? "green-score" : ""}
                                         `}>Score: {totalScore}</div>
                    </div>
                    <div className="apache-2-rating-container">
                        <div className="common-rating-cls">
                            <img className="rating-color" src={redRating} />
                            <span>Severe: 29+</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={yellowRating} />
                            <span>Moderate: 10 to 29</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={greenRating} />
                            <span>Safe: 0 to 9</span>
                        </div>
                    </div>
                </div>
                <div className="apache-2-mcq-container">
                    <div className="common-mcq">
                        <div className="mcq-heading">Chronic organ insufficiency or immunocompromise history</div>
                        <div className="mcq-score">{chronicOrganInsufficiencyRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="yes-emergency-surgery" name="chronic-organ-insufficiency" onClick={() => handleChronicOrganInsufficiencyRadio(5)} />
                                <label htmlFor="yes-emergency-surgery">Yes, and nonoperative or emergency postoperative patient(+5)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="yes-elective-surgery" name="chronic-organ-insufficiency" onClick={() => handleChronicOrganInsufficiencyRadio(2)} />
                                <label htmlFor="yes-elective-surgery">Yes, and elective postoperative patient(+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="no-surgery" name="chronic-organ-insufficiency" onClick={() => handleChronicOrganInsufficiencyRadio(0)} />
                                <label htmlFor="no-surgery">No(+0)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Age</div>
                        <div className="mcq-score">{ageRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="less-equal-44" name="age-option" onClick={() => handleAgeRadio(0)} />
                                <label htmlFor="less-equal-44">&le; 44 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="45to54" name="age-option" onClick={() => handleAgeRadio(2)} />
                                <label htmlFor="45to54">45-54 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="55to64" name="age-option" onClick={() => handleAgeRadio(3)} />
                                <label htmlFor="55to64">55-64 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="65to74" name="age-option" onClick={() => handleAgeRadio(5)} />
                                <label htmlFor="65to74">65-74 (+5)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="74plus" name="age-option" onClick={() => handleAgeRadio(6)} />
                                <label htmlFor="74plus">&gt;74 (+6)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Rectal Temperature, C</div>
                        <div className="mcq-score">{rectalTemperatureRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="41plus" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(4)} />
                                <label htmlFor="41plus">&ge;41 (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="39to40.9" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(3)} />
                                <label htmlFor="39to40.9">39-40.9 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="38.5to38.9" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(1)} />
                                <label htmlFor="38.5to38.9">38.5-38.9 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="36to38.4" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(0)} />
                                <label htmlFor="36to38.4">36-38.4(+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="34to35.9" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(1)} />
                                <label htmlFor="34to35.9">34-35.9 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="32to33.9" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(2)} />
                                <label htmlFor="32to33.9">32-33.9 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="30to31.9" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(3)} />
                                <label htmlFor="30to31.9">30-31.9 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-equal-29.9" name="rectal-temp" onClick={() => handleRectalTemperatureRadio(4)} />
                                <label htmlFor="less-equal-29.9">&le; 29.9 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Arterial pH</div>
                        <div className="mcq-score">{arterialpHRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="7.7plus" name="arterial-pH" onClick={() => handleArterialpHRadio(4)} />
                                <label htmlFor="7.7plus">&ge;7.70 (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="7.7to7.69" name="arterial-pH" onClick={() => handleArterialpHRadio(3)} />
                                <label htmlFor="7.7to7.69">7.60-7.69 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="7.5to7.59" name="arterial-pH" onClick={() => handleArterialpHRadio(1)} />
                                <label htmlFor="7.5to7.59">7.50-7.59 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="7.33to7.49" name="arterial-pH" onClick={() => handleArterialpHRadio(0)} />
                                <label htmlFor="7.33to7.49">7.33-7.49 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="7.25to7.32" name="arterial-pH" onClick={() => handleArterialpHRadio(2)} />
                                <label htmlFor="7.25to7.32">7.25-7.32 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="7.15to7.24" name="arterial-pH" onClick={() => handleArterialpHRadio(3)} />
                                <label htmlFor="7.15to7.24">7.15-7.24 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-than-7.15" name="arterial-pH" onClick={() => handleArterialpHRadio(4)} />
                                <label htmlFor="less-than-7.15">&lt; 7.15 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Mean Arterial pressure (mmHg)</div>
                        <div className="mcq-score">{meanArterialPressureRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="160plus-arterial" name="mean-arterial-pressure" onClick={() => handleMeanArterialPressureRadio(4)} />
                                <label htmlFor="160plus-arterial">&ge;160(+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="130to159-arterial" name="mean-arterial-pressure" onClick={() => handleMeanArterialPressureRadio(3)} />
                                <label htmlFor="130to159-arterial">130-159 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="110to129-arterial" name="mean-arterial-pressure" onClick={() => handleMeanArterialPressureRadio(2)} />
                                <label htmlFor="110to129-arterial">110-129 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="70to109-arterial" name="mean-arterial-pressure" onClick={() => handleMeanArterialPressureRadio(0)} />
                                <label htmlFor="70to109-arterial">70-109 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="50to69-arterial" name="mean-arterial-pressure" onClick={() => handleMeanArterialPressureRadio(2)} />
                                <label htmlFor="50to69-arterial">50-69 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-equal-49-arterial" name="mean-arterial-pressure" onClick={() => handleMeanArterialPressureRadio(4)} />
                                <label htmlFor="less-equal-49-arterial">&le; 49 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">HR (BPM)</div>
                        <div className="mcq-score">{hrRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="180plus-hr" name="hr-option" onClick={() => handleHrRadio(4)} />
                                <label htmlFor="180plus-hr">&ge;180 (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="140to179-hr" name="hr-option" onClick={() => handleHrRadio(3)} />
                                <label htmlFor="140to179-hr">140-179 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="110to139-hr" name="hr-option" onClick={() => handleHrRadio(2)} />
                                <label htmlFor="110to139-hr">110-139 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="70to109-hr" name="hr-option" onClick={() => handleHrRadio(0)} />
                                <label htmlFor="70to109-hr">70-109 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="55to69-hr" name="hr-option" onClick={() => handleHrRadio(2)} />
                                <label htmlFor="55to69-hr">55-69 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="40to54-hr" name="hr-option" onClick={() => handleHrRadio(3)} />
                                <label htmlFor="40to54-hr">40-54 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-equal-39-hr" name="hr-option" onClick={() => handleHrRadio(4)} />
                                <label htmlFor="less-equal-39-hr">&le; 39(+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Serum Sodium (mEq/L)</div>
                        <div className="mcq-score">{serumSodiumRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="180plus-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(4)} />
                                <label htmlFor="180plus-sodium">180+ (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="160to179-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(3)} />
                                <label htmlFor="160to179-sodium">160-179 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="155to159-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(2)} />
                                <label htmlFor="155to159-sodium">155-159 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="150to154-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(1)} />
                                <label htmlFor="150to154-sodium">150-154 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="130to149-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(0)} />
                                <label htmlFor="130to149-sodium">130-149 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="120to129-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(2)} />
                                <label htmlFor="120to129-sodium">120-129 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="111to119-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(3)} />
                                <label htmlFor="111to119-sodium">111-119 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-equalto110-sodium" name="serum-sodium" onClick={() => handleSerumSodiumRadio(4)} />
                                <label htmlFor="less-equalto110-sodium">&le; 110 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Serum Potassium (mEq/L)</div>
                        <div className="mcq-score">{serumPotassiumRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="7plus-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(4)} />
                                <label htmlFor="7plus-potassium">7+ (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="6to6.9-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(3)} />
                                <label htmlFor="6to6.9-potassium">6-6.9 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="5.5to5.9-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(1)} />
                                <label htmlFor="5.5to5.9-potassium">5.5-5.9 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3.5to5.4-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(0)} />
                                <label htmlFor="3.5to5.4-potassium">3.5-5.4 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3to3.4-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(1)} />
                                <label htmlFor="3to3.4-potassium">3-3.4 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="2.5to2.9-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(2)} />
                                <label htmlFor="2.5to2.9-potassium">2.5-3 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-than-2.5-potassium" name="serum-potassium" onClick={() => handleSerumPotassiumRadio(4)} />
                                <label htmlFor="less-than-2.5-potassium">&lt;2.5 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Acute Renal Failure</div>
                        <div className="mcq-score">{acuteRenalFailureRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="yes-renal-failure" name="renal-failure" onClick={() => {
                                    handleAcuteRenalFailureRadio(0);
                                    setAcuteYesNo('Y')
                                }} />
                                <label htmlFor="yes-renal-failure">Yes (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="no-renal-failure" name="renal-failure" onClick={() => {
                                    handleAcuteRenalFailureRadio(0);
                                    setAcuteYesNo('N')
                                }} />
                                <label htmlFor="no-renal-failure">No (+0)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Serum Creatinine (mg/dL)</div>
                        <div className="mcq-score">{serumCreatinineRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="3.5plus-creatinine" name="serum-creatinine" onClick={() => handleSerumCreatinineRadio(acuteYesNo === 'Y' ? 8 : 4)} />
                                <label htmlFor="3.5plus-creatinine">3.5+ (+8 or +4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="2to3.4-creatinine" name="serum-creatinine" onClick={() => handleSerumCreatinineRadio(acuteYesNo === 'Y' ? 6 : 3)} />
                                <label htmlFor="2to3.4-creatinine">2-3.4 (+6 or +3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="1.5to1.9-creatinine" name="serum-creatinine" onClick={() => handleSerumCreatinineRadio(acuteYesNo === 'Y' ? 4 : 2)} />
                                <label htmlFor="1.5to1.9-creatinine">1.5-1.9 (+4 or +2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="0.6to1.4-creatinine" name="serum-creatinine" onClick={() => handleSerumCreatinineRadio(0)} />
                                <label htmlFor="0.6to1.4-creatinine">0.6-1.4 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-than-0.6-creatinine" name="serum-creatinine" onClick={() => handleSerumCreatinineRadio(2)} />
                                <label htmlFor="less-than-0.6-creatinine">&lt; 0.6 (+2)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Hematocrit (mg/dL)</div>
                        <div className="mcq-score">{hematocritRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="60plus-hematocrit" name="serum-hematocrit" onClick={() => handleHematocritRadio(4)} />
                                <label htmlFor="60plus-hematocrit">&ge;60 (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="50to59.9-hematocrit" name="serum-hematocrit" onClick={() => handleHematocritRadio(2)} />
                                <label htmlFor="50to59.9-hematocrit">50-59.9 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="46to49.9-hematocrit" name="serum-hematocrit" onClick={() => handleHematocritRadio(1)} />
                                <label htmlFor="46to49.9-hematocrit">46-49.9 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="30to45.9-hematocrit" name="serum-hematocrit" onClick={() => handleHematocritRadio(0)} />
                                <label htmlFor="30to45.9-hematocrit">30-45.9 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="20to29.9-hematocrit" name="serum-hematocrit" onClick={() => handleHematocritRadio(2)} />
                                <label htmlFor="20to29.9-hematocrit">20-29.9 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-than-20-hematocrit" name="serum-hematocrit" onClick={() => handleHematocritRadio(4)} />
                                <label htmlFor="less-than-20-hematocrit">&lt; 20 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading"> WBC (x10^3 /µL)</div>
                        <div className="mcq-score">{wbcRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="40plus-wbc" name="wbc-option" onClick={() => handleWbcRadio(4)} />
                                <label htmlFor="40plus-wbc">&ge;40 (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="20to39.9-wbc" name="wbc-option" onClick={() => handleWbcRadio(2)} />
                                <label htmlFor="20to39.9-wbc">20-39.9 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="15to19.9-wbc" name="wbc-option" onClick={() => handleWbcRadio(1)} />
                                <label htmlFor="15to19.9-wbc">15-19.9 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3to14.9-wbc" name="wbc-option" onClick={() => handleWbcRadio(0)} />
                                <label htmlFor="3to14.9-wbc">3-14.9 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="1to2.9-wbc" name="wbc-option" onClick={() => handleWbcRadio(2)} />
                                <label htmlFor="1to2.9-wbc">1-2.9 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-than-1-wbc" name="wbc-option" onClick={() => handleWbcRadio(4)} />
                                <label htmlFor="less-than-1-wbc">&lt; 1 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading"> Oxygenation (use PaO2 if FiO2 &lt;50%, otherwise use A-a gradient)</div>
                        <div className="mcq-score">{oxygenationRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="A-a-grad-500+" name="oxygenation-option" onClick={() => handleOxygenationRadio(4)} />
                                <label htmlFor="A-a-grad-500+">A-a Gradient 500+ (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="A-a-grad-350-499" name="oxygenation-option" onClick={() => handleOxygenationRadio(3)} />
                                <label htmlFor="A-a-grad-350-499">A-a Gradient 350 - 499 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="A-a-grad-200-349" name="oxygenation-option" onClick={() => handleOxygenationRadio(2)} />
                                <label htmlFor="A-a-grad-200-349">A-a Gradient 200 - 349 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="A-a-grad-less-200" name="oxygenation-option" onClick={() => handleOxygenationRadio(0)} />
                                <label htmlFor="A-a-grad-less-200">A-a Gradient &lt; 200 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="pao2-70+" name="oxygenation-option" onClick={() => handleOxygenationRadio(0)} />
                                <label htmlFor="pao2-70+">PaO2 70+ (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="pao2-61-70" name="oxygenation-option" onClick={() => handleOxygenationRadio(1)} />
                                <label htmlFor="pao2-61-70">PaO2 61 - 70 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="pao2-55-60" name="oxygenation-option" onClick={() => handleOxygenationRadio(3)} />
                                <label htmlFor="pao2-55-60">PaO2 55 - 60 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="pao2-less-55" name="oxygenation-option" onClick={() => handleOxygenationRadio(4)} />
                                <label htmlFor="pao2-less-55">PaO2 &lt; 55(+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading"> Respiratory Rate</div>
                        <div className="mcq-score">{repiratoryRateRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="50plus-rr" name="respiratory-rate-option" onClick={() => handleRespiratoryRateRadio(4)} />
                                <label htmlFor="50plus-rr">&ge;50 (+4)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="35to50-hr" name="respiratory-rate-option" onClick={() => handleRespiratoryRateRadio(3)} />
                                <label htmlFor="35to50-hr">35 to &lt;50 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="25to34-hr" name="respiratory-rate-option" onClick={() => handleRespiratoryRateRadio(1)} />
                                <label htmlFor="25to34-hr">25 to &lt;35 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="12to24-hr" name="respiratory-rate-option" onClick={() => handleRespiratoryRateRadio(0)} />
                                <label htmlFor="12to24-hr">12 to &lt;25 (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="10to11-hr" name="respiratory-rate-option" onClick={() => handleRespiratoryRateRadio(1)} />
                                <label htmlFor="10to11-hr">10 to &lt;12 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="6to9-hr" name="respiratory-rate-option" onClick={() => handleRespiratoryRateRadio(2)} />
                                <label htmlFor="6to9-hr">6 to &lt;10 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="less-than-6-hr" name="respiratory-rate-option" onClick={() => handleOxygenationRadio(4)} />
                                <label htmlFor="less-than-6-hr">&lt;6 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq gcs-option">
                        <div className="mcq-heading"> GCS Score</div>
                        <div className="mcq-score">{gcsScore}</div>
                        <input type="text" className="gcs-input-text" onInput={(event) => handleGcsScoreRadio(event.target.value)} />
                    </div>
                </div>
                <div className="apache-2-total-rating-container">
                    <span>Total Apache II Score</span>
                    <div className="total-rating">{totalScore}</div>
                </div>
                <div className="submit-btn-container">
                    <div className="submit-btn" onClick={() => props.handleSubmitClick(totalScore)}>Submit</div>
                </div>
            </div>

        </div>
    )
}
export default Apache2Score;
